var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// d:/Vagrant/apache_vm/edu/wp-content/themes/portaledu-escolas/node_modules/core-js/modules/_shared-key.js
// module id = 68
// module chunks = 0